// extracted by mini-css-extract-plugin
var _1 = "mYzc_Tlnbjxo4FYe8Xsw";
export { _1 as "icon" }
